// 9fbef606107a605d69c0edbcd8029e5d

export const getAdyenSessionData = (state) => {
  return state.AdyenPayment.get('adyenSessionData');
};

export const getAdyenSetupData = (state) => {
  return state.AdyenPayment.get('adyenSetupData');
};
